// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".switch-toggle--wTArU.rc-switch:not(.rc-switch-disabled)::after{transition:left 320ms cubic-bezier(0.22, 1, 0.36, 1),width 200ms cubic-bezier(0.22, 1, 0.36, 1)}.switch-toggle--wTArU.rc-switch:not(.rc-switch-disabled):active::after{width:24px}.switch-toggle--wTArU.rc-switch:not(.rc-switch-disabled).rc-switch-checked:active::after{left:16px}@media(prefers-reduced-motion: reduce){.switch-toggle--wTArU.rc-switch:not(.rc-switch-disabled)::after{transition:none}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"switch-toggle": "switch-toggle--wTArU"
};
export default ___CSS_LOADER_EXPORT___;
